<template>
  <b-modal
    id="modal-delete-search"
    :title="`Delete Bookmark '${bookmarkToDelete.title}'?`"
    centered
    hide-footer
  >
    <p class="font-weight-bold">
      The note below is associated with this bookmark. Are you sure you want to
      delete it?
    </p>
    <b-form-textarea
      plaintext
      :value="bookmarkToDelete.note"
      rows="3"
      max-rows="6"
      no-resize
    ></b-form-textarea>
    <div class="modal-footer">
      <b-button class="mt-2 footer-btn" variant="secondary" @click="hideModal"
        >Cancel</b-button
      >
      <b-button class="mt-2 footer-btn" variant="primary" @click="confirmDelete"
        >Confirm
      </b-button>
    </div>
  </b-modal>
</template>
<script>
export default {
  name: 'DeleteSearch',
  props: {
    bookmarkToDelete: Object,
  },
  methods: {
    confirmDelete() {
      this.$store.dispatch('DELETE_SEARCH', {
        id: this.bookmarkToDelete.id,
      });
      this.$bvModal.hide('modal-delete-search');
    },
    hideModal() {
      this.$bvModal.hide('modal-delete-search');
    },
  },
};
</script>
<style scoped>
.modal-footer {
  display: flex;
  justify-content: space-between;
}
.footer-btn {
  width: 40%;
}
</style>
